import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import { fetchJsonRead } from "../../services/readRequest";

export const fetchCommunitySortOrder = createAsyncThunk(
  "communitySortOrder/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchJsonRead(
        `${baseUrl}/api/app/community/sort-order`,
        { headers: headersDefault() },
      );
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Errore nel caricamento dell'ordinamento community",
      );
    }
  },
  {
    condition: (_, { getState }) => {
      const slice = getState().communitySortOrder;
      return !slice?.isLoading && !slice?.isLoaded;
    },
  },
);
